import { useMutation, useQueryClient } from 'react-query';
import { updateUserPreferences, type UserPreferences } from '../../services/userService';

export function useUpdateUserPreferences() {
  const queryClient = useQueryClient();
  return useMutation((preferences: UserPreferences) => updateUserPreferences(preferences), {
    onSuccess: () => {
      queryClient.invalidateQueries(['userPreferences']);
    }
  });
}
